import { apiRequest } from "@portal/lib/ky/utils";
import { PortalAnonyDetailsDTO } from "@portal/types/entities/portalui";

export async function getVisualConfigs() {
  const data = await apiRequest<unknown, PortalAnonyDetailsDTO>({
    method: "GET",
    url: `v1/accounts/anon-details`,
  });
  return await data.json();
}
